module.exports = __webpack_public_path__ + "img/2.63f6e7a3.png";